import { useResetPasswordPage } from "./logic";
import { ResetPasswordPageTemplate } from "./template";

export const ResetPasswordPage = (): JSX.Element => {
  const data = useResetPasswordPage();
  return <ResetPasswordPageTemplate {...data} />;
};
